import * as actions from "./actionsType";

const initialData = {
  loaderMotivos: false,
  motivos: null,
  motivosFalla: null,
  saveLoaderMotivos: false,
  motivosFormError:null
};

export default function MotivosReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_MOTIVOS:
      return { ...state, loaderMotivos: action.payload };

    case actions.GET_MOTIVOS:
      return { ...state, motivos: action.payload };

    case actions.MOTIVOS_FALLA:
      return { ...state, motivosFalla: action.payload };

    case actions.SAVE_LOADER_MOTIVOS:
      return { ...state, saveLoaderMotivos: action.payload };

    case actions.FORM_MOTIVOS_FAIL:
      return { ...state, motivosFormError: action.payload };
      
    default:
      return state;
  }
}
